import * as React from "react";
export default class Breadcrumb extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "breadcrumb" },
            React.createElement("div", { className: "section" },
                React.createElement("a", { href: "/" }, "Home")),
            this.props.NavList.map((NavItem, index) => {
                return React.createElement("div", { className: "section", key: index },
                    React.createElement("i", { className: "fa fa-angle-right" }),
                    React.createElement("a", { href: NavItem.Link }, NavItem.Text));
            })));
    }
}
;
//# sourceMappingURL=breadcrumb.js.map